/**
 * @generated SignedSource<<d9766d8a5a9218d74daf9a0dfb0398af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type singlePersonKnowledgeCardRelay_smarts$data = {
  readonly recommendedUser: ReadonlyArray<{
    readonly user: {
      readonly accountId: string;
      readonly email?: string | null | undefined;
      readonly extendedProfile?: {
        readonly jobTitle: string | null | undefined;
      } | null | undefined;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "singlePersonKnowledgeCardRelay_smarts";
};
export type singlePersonKnowledgeCardRelay_smarts$key = {
  readonly " $data"?: singlePersonKnowledgeCardRelay_smarts$data;
  readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_smarts">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "recommendationsQuery"
    }
  ],
  "kind": "Fragment",
  "name": "singlePersonKnowledgeCardRelay_smarts",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "recommendationsQuery",
          "variableName": "recommendationsQuery"
        }
      ],
      "concreteType": "SmartsRecommendedUser",
      "kind": "LinkedField",
      "name": "recommendedUser",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "picture"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                },
                {
                  "concreteType": "AtlassianAccountUserExtendedProfile",
                  "kind": "LinkedField",
                  "name": "extendedProfile",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "jobTitle"
                    }
                  ]
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    }
  ],
  "type": "SmartsQueryApi"
};

(node as any).hash = "28c563bfe5ced2c4dbd6c2c333de65db";

export default node;
